import React, { useState, useRef } from "react";
import { css, AmountInput, DateInput, CustomDropdown, TextInput, StatusBanner, AdditionalInfo } from "../components/InvestmentForms/SharedComponents";

const TRANSACTION_OPTIONS = [
    { value: "Purchase of Shares",                label: "Purchase of Shares" },
    { value: "Sale of Shares to Third Party",     label: "Sale of Shares to Third Party" },
    { value: "Buyback by Investee from Investor", label: "Buyback by Investee from Investor" },
    { value: "Subscription to Rights Issue",      label: "Subscription to Rights Issue" },
    { value: "Stock Split by Investee",           label: "Stock Split by Investee" },
    { value: "Bonus Issue by Investee",           label: "Bonus Issue by Investee" },
];


const SaleOfSharesForm = ({ fd, hc, companyOptions, selectedTransaction, onTransactionChange }) => (
    <div style={{
        border: "1px solid #eaeeed",
        borderRadius: "12px",
        padding: "20px",
        backgroundColor: "#fff",
        marginBottom: "16px"
    }}>
        <div style={{ marginBottom: "20px" }}>
            <CustomDropdown
                label="Nature Of Transaction"
                options={TRANSACTION_OPTIONS}
                placeholder="Select Transaction Type"
                value={selectedTransaction}
                onChange={onTransactionChange}
                fullWidth
            />
        </div>
        <div className={css.formContainer}>
            <DateInput label="Transaction Date" value={fd.transactionDate} onChange={v => hc("transactionDate", v)} />
            <CustomDropdown label="Investor Company" options={companyOptions} placeholder="Select Investor" value={fd.investorCompany} onChange={v => hc("investorCompany", v)} />
            <CustomDropdown label="Investee Company" options={companyOptions} placeholder="Select Investee" value={fd.investeeCompany} onChange={v => hc("investeeCompany", v)} />
            <TextInput label="No Of Shares Sold" placeholder="Enter No Of Shares" value={fd.noOfSharesSold} onChange={v => hc("noOfSharesSold", v)} />
            <AmountInput label="Sale Price Per Share" value={fd.salePricePerShare} onChange={v => hc("salePricePerShare", v)} />
            <AmountInput label="Total Sale Proceeds" value={fd.totalSaleProceeds} onChange={v => hc("totalSaleProceeds", v)} />
            <CustomDropdown label="Cost Basis Method" options={[{ value: "FIFO", label: "FIFO" }, { value: "LIFO", label: "LIFO" }, { value: "Average", label: "Average Cost" }]} placeholder="Select method" value={fd.costBasisMethod} onChange={v => hc("costBasisMethod", v)} />
            <AmountInput label="Cost Of Shares Sold" value={fd.costOfSharesSold} onChange={v => hc("costOfSharesSold", v)} />
            <AmountInput label="Gain Or Loss In Sale" value={fd.gainOrLoss} onChange={v => hc("gainOrLoss", v)} />
            <CustomDropdown label="Sold To" options={companyOptions} placeholder="Select company or type buyer name" value={fd.soldTo} onChange={v => hc("soldTo", v)} />
        </div>
    </div>
);


const StatusContainer = ({ relationship, onRelChange }) => (
    <StatusBanner relationship={relationship} onRelChange={onRelChange} />
);


const AdditionalInfoContainer = ({ formData, onChange, projectOptions, consolList }) => (
    <AdditionalInfo formData={formData} onChange={onChange} projectOptions={projectOptions} consolList={consolList}/>
);


const AttachValuationContainer = () => {
  const fileInputRef = useRef(null);
  const [selectedFile, setSelectedFile] = useState(null);

  const handleDrop = (e) => {
    e.preventDefault();
    if (e.dataTransfer.files?.length) {
      setSelectedFile(e.dataTransfer.files[0]);
    }
  };

  const handleFileChange = (e) => {
    if (e.target.files?.length) {
      setSelectedFile(e.target.files[0]);
    }
  };

  const removeFile = () => {
    setSelectedFile(null);
    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
  };

  return (
    <div
      style={{
        borderRadius: "14px",
        padding: "24px 10px",
        marginBottom: "16px",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <label className={css.label}>
        Attach Valuation Report
      </label>

      <div
        className={css.dragBox}
        onDragOver={(e) => e.preventDefault()}
        onDrop={handleDrop}
        onClick={() => fileInputRef.current?.click()}
      >
        Drag and drop your file here
      </div>

      <input
        ref={fileInputRef}
        type="file"
        accept=".pdf,.txt,.csv,.xls,.xlsx,.doc,.docx"
        style={{ display: "none" }}
        onChange={handleFileChange}
      />

      {selectedFile && (
        <div
          style={{
            marginTop: "14px",
            border: "1px solid #EAEEED",
            borderRadius: "8px",
            padding: "10px 14px",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",

          }}
        >
          <span
            style={{
              fontSize: "14px",
              color: "#205a46",
              fontWeight: "500",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
              maxWidth: "80%",
            }}
          >
            {selectedFile.name}
          </span>

          <button
            onClick={removeFile}
            style={{
              background: "none",
              border: "none",
              cursor: "pointer",
              color: "#8FAAA3",
              fontSize: "16px",
            }}
          >
            ✕
          </button>
        </div>
      )}
    </div>
  );
};


const NotesContainer = ({ formData, onChange }) => (
    <div className={css.notesOnlyCard}>
        <label className={css.label}>Notes / Remarks</label>
        <textarea
            className={css.notesTextarea}
            placeholder="Placeholder text"
            value={formData.notesRemarks || ""}
            onChange={e => onChange("notesRemarks", e.target.value)}
        />
    </div>
);


const SaleOfShares = ({ formData, onChange, relationship, onRelChange, projectOptions, consolList, companyOptions, selectedTransaction, onTransactionChange }) => (
    <>

        <SaleOfSharesForm
            fd={formData}
            hc={onChange}
            companyOptions={companyOptions}
            selectedTransaction={selectedTransaction}
            onTransactionChange={onTransactionChange}
        />

        <StatusContainer
            relationship={relationship}
            onRelChange={onRelChange}
        />

        <AdditionalInfoContainer
            formData={formData}
            onChange={onChange}
            projectOptions={projectOptions}
            consolList={consolList}
        />

      
        <AttachValuationContainer />

        <NotesContainer
            formData={formData}
            onChange={onChange}
        />
    </>
);

export default SaleOfShares;